import { getLogOrdersByOrderId } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const fetcher = async (request: [string, string]) => {
  const [orderId] = request;
  return getLogOrdersByOrderId(orderId);
};

const useLogOrdersByOrderId = (id: string | undefined) => {
  const {
    data,
    isValidating: logOrdersLoading,
    error: logOrdersError,
  } = useSWR(id ? [id, 'log-orders'] : null, fetcher, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    logOrders: data,
    logOrdersLoading,
    logOrdersError,
  };
};

export default useLogOrdersByOrderId;
